import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIsFramed } from 'site-modules/shared/hooks/use-is-framed';
import { AiLinkContent } from 'site-modules/shared/components/ai-link/ai-link-content';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PageModel } from 'client/data/models/page';
import { buildAiAssistantUrl } from 'site-modules/shared/utils/ai-assistant-url';
import { GlobalNavLink } from './global-nav-link';

const AiNavigationLinkUI = memo(({ location }) => {
  const canvasUrl = buildAiAssistantUrl(location);
  const isFramed = useIsFramed();
  const aiLinkConfig = useMemo(
    () =>
      isFramed
        ? {
            attributes: {
              tag: 'span',
            },
          }
        : {
            trackingId: 'open_chat_canvas',
            'data-tracking-ignore-value': true,
            url: canvasUrl,
            attributes: {
              rel: 'nofollow',
            },
          },
    [canvasUrl, isFramed]
  );

  return (
    <GlobalNavLink link={aiLinkConfig} pathname={location.pathname}>
      <span className="d-inline-flex justify-content-center align-items-center">
        <AiLinkContent newLabelClasses="with-bg-dark text-white ms-0" withSparkle />
      </span>
      <div className="mt-0_25 size-14">Ask anything from reviews to pricing to deals.</div>
    </GlobalNavLink>
  );
});

AiNavigationLinkUI.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

AiNavigationLinkUI.displayName = 'AiNavigationLinkUI';

export const AiNavigationLink = connectToModel(AiNavigationLinkUI, {
  location: bindToPath('location', PageModel, null, false),
});
